












































































































































































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import SimpleDialog from '@c/SimpleDialog.vue';
import IntervalDateTimeSelect from '@c/IntervalDateTimeSelect.vue';
import {DatesIntervals, DateTimeInterval, dateTimeIntervalHandle} from '@u/dateTimeItervalUtils';
import SelectDialogField from '@c/controls/selectControls/SelectDialogField.vue';
import Loading from '@c/controls/Loading.vue';
import Card from '@c/Card.vue';
import {uuidv4} from '@/utils/uuidUtils';
import VibrationDiagramBox from '@/components/services/vibrationDiagnostic/VibrationDiagramBox.vue';
import VibrationWaterfallBox from '@/components/services/vibrationDiagnostic/VibrationWaterfallBox.vue';
import waterfallDiagramStoreModule from '@/store/modules/waterfallDiagramModule';
import SpectrumDiagramBox from '@c/diagrams/SpectrumDiagramBox.vue';
import DiagramsToCompareBox from '@c/diagrams/DiagramsToCompareBox.vue';
import AngleDiagramBox from '@c/diagrams/AngleDiagramBox.vue';
import {Can} from '@casl/vue';
import diagramStoreModule from '@/store/modules/signalDiagramModule';
import spectrumDiagramStoreModule from '@/store/modules/spectrumDiagramModule';
import {CursorData, CursorDiagramState} from '@/logic/cursorDiagramState';
import {CursorType} from '@/enums/diagrams';
import vibrationDiagnosticStoreModule from '@/store/modules/services/vibrationDiagnosticModule';
import {Splitpanes, Pane} from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import {getAllModules} from '@/store/modules/entities/pmodules/pmoduleWithMeasurementsModule';
import {
  DtcpAccelerometerModule,
  PModule,
  PModuleWithMeasurements,
} from '@/views/system/modules/interfaces';
import {PModuleType} from '@/enums/configs';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import measurementsModule from '@/store/modules/entities/measurementsModule';
import {measurementAliasPModule} from '@/components/services/vibrationDiagnostic/configurate';
import {
  SignalDiagramData,
  SpectrumDiagramData,
  WaterfallSpectrumDiagramData,
  AngleDiagramData,
} from '@/components/diagrams/interfaces';
import {pmoduleTypeFilter} from '@/components/nodeComponent/filters';
import {pmoduleGroupings} from '@/components/nodeComponent/groupings';
import {
  SelectionListFilterModel,
  SelectionListGroupingModel,
} from '@/components/controls/selectionList/interfaces';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import {MeasurementType} from '@/views/system/measurements/enums';
import {VibrationDiagnosticAction} from './enums';
import SignalDiagramBox from '@c/diagrams/SignalDiagramBox.vue';
import {SpectrumYAxisType, SpectrumEventType} from '@/enums/diagrams';
import {spectrumYAxisTypes} from '@/api/configurate';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import {Freqband} from '@/interfaces/diagrams';
import {DiagramSettings, SpectrumDiagramSettings} from './interfaces';
import userSettingsStoreModule from '@/store/modules/userSettingsModule';
import dtcpAccelerometerStoreModule from '@/store/modules/entities/pmodules/dtcp/dtcpAccelerometerStoreModule';
import dtcpTahoModule from '@/store/modules/entities/pmodules/dtcp/dtcpTahoStoreModule';
import IconButton from '@c/controls/IconButton.vue';
import router from '@/router';
import {httpClient} from '@/api/baseApi';

@Component({
  components: {
    SimpleDialog,
    IntervalDateTimeSelect,
    SelectDialogField,
    Loading,
    Card,
    SignalDiagramBox,
    VibrationDiagramBox,
    VibrationWaterfallBox,
    SpectrumDiagramBox,
    DiagramsToCompareBox,
    AngleDiagramBox,
    Can,
    Splitpanes,
    Pane,
    SelectionList,
    IconButton,
  },
})
export default class VibrationDiagnostic extends Vue {
  // id набора
  collectionId!: number;

  // Модель кнопки редактирования
  editButton = false;

  // Показатель режима редактирования
  edit = false;

  // Цвет кнопки редактирования
  get editButtonColor() {
    return this.edit ? 'red' : 'blue';
  }

  // Диалоговое окно для установки параметров
  paramsDialog = false;

  // timestamp, полученный по курсору
  spectrumSliceTimestamp: number | null = null;

  freqbands: Freqband[] = [];
  dtcpAccelerometerModules: any = {};

  // Собираем freqbands по id программых модулей.
  freqbandsForPModule: Map<number, Freqband[]> = new Map();

  /*
    Т.к. в наборе не сохраняется дата и при открытии страницы открывается сразу диалоговое окно с выбором дат и датчиков, и есть проблема что дата подгружается позже чем начинаются отображать графики, то такое сложное условие
  */
  get showDiagrams() {
    return (
      this.vibrationDiagramLoading ||
      ((!!this.initDateTimeInterval || !!this.currentDateTimeInterval) &&
        !!this.selectedAccelerometerGUID)
    );
  }
  /*
    Computed поле, привязанное к vuex и watcher для него
  */
  get sync() {
    return diagramStoreModule.sync;
  }

  @Watch('sync')
  async syncChanged(sync: {
    syncModes: any[];
    syncDiagrams: any[];
    syncedState: CursorDiagramState;
  }) {
    const stateValue = sync.syncedState;
    // получаем timestamp и по нему спектры
    if (stateValue) {
      const cursorData: CursorData = stateValue.cursorData.find(
        c => c.type == CursorType.Cursor,
      ) as CursorData;
      if (cursorData && cursorData.pointX)
        this.spectrumSliceTimestamp = Math.round(cursorData.pointX);
      else this.skipSpectrumsToRightBound();
    } else this.skipSpectrumsToRightBound();
  }

  async addToCompare(diagram: any, timestamp: any, freqbands: any) {
    const element = {...diagram};
    element.time = timestamp;
    element.freqbands = freqbands;
    element.visible = true;

    const index = this.diagramsToCompare.findIndex(x => x[0].id == element.id);
    if (index != -1) {
      if (!this.diagramsToCompare[index].map((x: any) => x.time).includes(element.time))
        this.diagramsToCompare[index].push(element);
    } else {
      const array = [];
      array.push(element);
      this.diagramsToCompare.push(array);
    }
    this.diagramsKey++;
  }

  addNewSpectrums(timestamps: any, id: any) {
    const index = this.diagramsToCompare.findIndex(x => x[0].id == id);
    timestamps.forEach((timestamp: any) => {
      const diagram = {...this.diagramsToCompare[index][0]};
      diagram.time = timestamp;
      diagram.visible = true;
      this.diagramsToCompare[index].push(diagram);
    });
    this.diagramsKey++;
  }

  async skipSpectrumsToRightBound() {
    this.spectrumSliceTimestamp = this.currentDateTimeInterval.endDateTime as number;
  }

  currentDateTimeInterval!: DateTimeInterval;

  initDateTimeInterval: DateTimeInterval | null = null;

  fieldRequiredRules = [(v: any) => !!v || 'Поле обязательно для заполнения'];

  formValid = false;

  // Список программных модулей
  pmodules: PModuleWithMeasurements[] = [];

  selectedAccelerometerGUID = '';

  pmoduleAccelerometer: PModuleWithMeasurements | null = null;

  selectedTahoGUID = '';

  pmoduleTaho: PModuleWithMeasurements | null = null;

  span_nodes: any[] | null = null;

  //Список всех измерений
  measurements: MeasurementData[] = [];

  comparedDiagrams: SignalDiagramData[] = [];

  stdDevDiagram: SignalDiagramData | null = null;

  waterfallDiagram: WaterfallSpectrumDiagramData | null = null;

  angleDiagram: AngleDiagramData | null = null;

  // Показатели загрузки данных и наличия ошибок
  diagramLoading = false;
  loading = false;
  error = false;
  vibrationDiagramLoading = false;
  angleDiagramLoading = false;

  pmodulesLoading = true;
  pmodulesError = false;

  // Диалоговое окно для выбора программных модулей
  pmodulesDialog = false;

  // Список выбранных программных модулей
  selectedPModulesGuids: string[] = [];

  // Сохраняем выбранные идентификаторы при открытии диалога
  dialogSelectedPModulesGuids: string[] = [];

  // Фильтр программных модулей по типу
  pmoduleTypeFilter: SelectionListFilterModel = pmoduleTypeFilter;

  // Список группировок программных модулей
  pmoduleGroupings: SelectionListGroupingModel[] = pmoduleGroupings;

  diagramsKey = 0;

  @Watch('pmodulesDialog')
  onConfigsDialog(value: boolean) {
    if (value) this.dialogSelectedPModulesGuids = [...this.selectedPModulesGuids];
  }

  //Действия при выборе программных модулей
  //Добавляем все сигналы из выбранных модулей, которых еще нет в списке сравниваемых графиков
  onSelectPModules() {
    this.selectedPModulesGuids = [...this.dialogSelectedPModulesGuids];
    this.pmodulesDialog = false;

    this.selectedPModulesGuids.forEach((guid: string) => {
      const pmodule = this.pmodules.filter(x => x.guid === guid)[0];

      pmodule.measurements.forEach(x => {
        const measurement = this.measurements.find(y => y.id === x.measurementId);
        if (!measurement || measurement.type !== MeasurementType.Signal) return;

        const moduleId = pmodule?.id as number;
        const moduleGUID = pmodule?.guid as string;
        const moduleType = pmodule?.type as PModuleType;

        if (
          this.comparedDiagrams.some(
            x => x.moduleGUID === moduleGUID && x.measurement.id === measurement.id,
          ) ||
          this.detachedSignalDiagrams.some(
            x => x.moduleGUID === moduleGUID && x.measurement.id === measurement.id,
          )
        )
          return;

        this.comparedDiagrams.push({
          id: uuidv4(),
          name: `${pmodule?.name}: ${measurement.shortName}`,
          moduleId: moduleId,
          moduleGUID: moduleGUID,
          moduleType: moduleType,
          measurement: measurement,
          visible: true,
        });
      });
    });

    //удаляем графики, для которых сняли "галку", оставляем сигналы акселерометра и такхометра из настроек
    this.comparedDiagrams = this.comparedDiagrams.filter(
      (diagram: SignalDiagramData) =>
        this.selectedPModulesGuids.includes(diagram.moduleGUID) ||
        diagram.moduleGUID === this.pmoduleTaho?.guid ||
        (diagram.moduleGUID === this.selectedAccelerometerGUID &&
          diagram.moduleType === PModuleType.DtcpAccelerometerModule),
    );

    this.detachedSignalDiagrams = this.detachedSignalDiagrams.filter(
      (diagram: SignalDiagramData) =>
        this.selectedPModulesGuids.includes(diagram.moduleGUID) ||
        diagram.moduleGUID === this.pmoduleTaho?.guid,
    );

    this.addAppropriateSpectrums();
  }

  // Получить наименование для строки таблицы freqband в зависимости от значений в ней
  getNameFreqbandItem(central_frequency?: number, bandwidth?: number) {
    const cf = central_frequency ? `ц.ч. ${central_frequency}` : '';
    const bw = bandwidth ? `ш.п. ${bandwidth}` : '';
    return cf ? `${cf}${bw ? ';' : ''} ${bw}` : bw;
  }

  // Для добавляемых сигналов выбранных модулей, добавляем на уже существующие диаграммы спектров
  // соответствующие измерениям и типам осей спектры выбранных модулей
  addAppropriateSpectrums() {
    this.selectedPModulesGuids.forEach((guid: string) => {
      const pmodule = this.pmodules.filter(x => x.guid === guid)[0];

      pmodule.measurements.forEach(x => {
        const measurement = this.measurements.find(y => y.id === x.measurementId);
        if (!measurement || measurement.type === MeasurementType.Signal) return;

        const moduleId = pmodule?.id as number;
        const moduleGUID = pmodule?.guid as string;
        const moduleType = pmodule?.type as PModuleType;

        if (
          this.spectrumDiagrams.some(
            x =>
              x.mainDiagram.moduleGUID === moduleGUID &&
              x.mainDiagram.measurement.id === measurement.id,
          )
        )
          return;

        if (measurement.spectrumType === SpectrumEventType.Low) {
          spectrumYAxisTypes.forEach((item: {value: SpectrumYAxisType; name: string}) => {
            const mainSpectrum = this.spectrumDiagrams.filter(
              (d: any) =>
                d.mainDiagram.moduleType === moduleType &&
                d.mainDiagram.measurement.id === measurement.id &&
                d.mainDiagram?.spectrumYAxisType === item.value,
            )[0];
            if (mainSpectrum)
              mainSpectrum.comparedDiagrams.push({
                id: this.getSpectrumId(moduleGUID, measurement?.id as number, item.value),
                name: this.getSpectrumTitle(pmodule?.name, measurement.shortName, item.name),
                moduleId: moduleId,
                moduleGUID: moduleGUID,
                moduleType: moduleType,
                measurement: measurement,
                spectrumYAxisType: item.value,
              });
          });
        } else {
          const mainSpectrum = this.spectrumDiagrams.filter(
            (d: any) =>
              d.mainDiagram.moduleType === moduleType &&
              d.mainDiagram.measurement.id === measurement.id,
          )[0];
          if (mainSpectrum)
            mainSpectrum.comparedDiagrams.push({
              id: this.getSpectrumId(moduleGUID, measurement?.id as number),
              name: this.getSpectrumTitle(pmodule?.name, measurement.shortName),
              moduleId: moduleId,
              moduleGUID: moduleGUID,
              moduleType: moduleType,
              measurement: measurement,
            });
        }
      });
    });
  }

  //Получаем список модулей без уже выбранного модуля акселерометра и тахометра
  get pmodulesWithoutMain() {
    return this.pmodules.filter(
      x => x.guid !== this.selectedAccelerometerGUID && x.guid !== this.selectedTahoGUID,
    );
  }

  get selectedAccelerometerId() {
    if (this.selectedAccelerometerGUID)
      return this.pmodules.find(x => x.guid == this.selectedAccelerometerGUID)?.id;
    return null;
  }

  // Имя набора датчиков
  collectionName = '';

  // Отображение графика угла фазы
  showAngleDiagram = false;

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  saveHint = false;

  textHint = 'Набор сохранен';

  formCollectionNameValid = true;

  // Ключ для перерисовки диаграмм
  resizedKey = 0;

  // Действия при изменении размера pane
  onPaneResized() {
    this.resizedKey++;
  }

  setDateTimeInterval(currentDateTimeInterval: DateTimeInterval) {
    this.currentDateTimeInterval = currentDateTimeInterval;
  }

  //Действия при установке параметров
  async loadChart(created: any) {
    this.error = false;
    this.diagramLoading = true;
    this.vibrationDiagramLoading = true;
    this.angleDiagramLoading = true;

    try {
      this.pmoduleAccelerometer = this.pmodules.filter(
        x => x.guid === this.selectedAccelerometerGUID,
      )[0];

      const availableMeasurements = measurementAliasPModule.get(this.pmoduleAccelerometer?.type);
      if (!availableMeasurements) return;

      const stdDevMeasurement = this.measurements.find(x => {
        if (!this.pmoduleAccelerometer?.type) return false;

        return (
          x.alias === availableMeasurements?.main &&
          this.pmoduleAccelerometer.measurements.find(y => y.measurementId === x.id)
        );
      });

      const moduleId = this.pmoduleAccelerometer?.id as number;
      const moduleGUID = this.pmoduleAccelerometer?.guid as string;
      const moduleType = this.pmoduleAccelerometer?.type as PModuleType;

      const angleMeasurements = this.measurements.filter(
        x => x.alias.includes('angle') || x.alias.includes('amplitude'),
      );

      let isAngleMeasurements = false;

      angleMeasurements.forEach((m: any) => {
        if (this.pmoduleAccelerometer?.measurements.map(x => x.measurementId).includes(m.id))
          isAngleMeasurements = true;
      });

      this.waterfallDiagram = {
        id: uuidv4(),
        name: 'Диаграмма водопада спектров',
        moduleId: moduleId,
        moduleGUID: moduleGUID,
        moduleType: moduleType,
      };

      if (isAngleMeasurements) {
        this.angleDiagram = {
          id: uuidv4(),
          name: 'Диаграмма отображения угла фазы',
          moduleId: moduleId,
          moduleGUID: moduleGUID,
          moduleType: moduleType,
          measurements: angleMeasurements,
        };
      } else this.angleDiagram = null;

      if (stdDevMeasurement) {
        this.stdDevDiagram = {
          id: uuidv4(),
          name: `${this.pmoduleAccelerometer?.name}: ${stdDevMeasurement.shortName}`,
          moduleId: moduleId,
          moduleGUID: moduleGUID,
          moduleType: moduleType,
          measurement: stdDevMeasurement,
          visible: true,
        };
      }

      if (this.angleDiagram && this.stdDevDiagram) {
        diagramStoreModule.setCanSync({
          diagrams: [this.stdDevDiagram, this.waterfallDiagram, this.angleDiagram],
          syncDiagrams: [this.stdDevDiagram, this.waterfallDiagram, this.angleDiagram],
        });
      }

      //для трехосного dtcp-accelerometer в compared добавляем остальные оси
      if (availableMeasurements?.compared) {
        availableMeasurements?.compared.forEach((alias: string) => {
          const measurement = this.measurements.find(
            x =>
              x.alias === alias &&
              this.pmoduleAccelerometer?.measurements.find(y => y.measurementId === x.id),
          );

          if (
            measurement &&
            !this.comparedDiagrams.find(
              d => d.moduleGUID === moduleGUID && d.measurement.id === measurement.id,
            )
          ) {
            this.comparedDiagrams.push({
              id: uuidv4(),
              name: `${this.pmoduleAccelerometer?.name}: ${measurement.shortName}`,
              moduleId: moduleId,
              moduleGUID: moduleGUID,
              moduleType: moduleType,
              measurement: measurement,
              visible: true,
            });
          }
        });
      }

      if (!created) {
        this.dialogSelectedSpectrumsIds = [];

        this.selectedSpectrumsIds.forEach(id => {
          const spectrum = this.allSpectrum.filter(x => x.id == id)[0];
          const measurement = spectrum.measurement.id;
          const type = spectrum.spectrumYAxisType;

          const newDiagram = this.allSpectrum.filter(
            x =>
              x.measurement.id == measurement &&
              x.spectrumYAxisType == type &&
              x.moduleId == this.pmoduleAccelerometer?.id,
          )[0];
          if (newDiagram) {
            this.dialogSelectedSpectrumsIds.push(newDiagram.id);
          }
          this.onSelectSpectrums();
        });
      }

      if (this.selectedTahoGUID) {
        //получаем модель для выбранного тахометра
        this.pmoduleTaho = this.pmodules.filter(x => x.guid === this.selectedTahoGUID)[0];
        const meanMeasurement = this.measurements.find(x => {
          if (!this.pmoduleTaho?.type) return false;
          return (
            x.alias === measurementAliasPModule.get(this.pmoduleTaho?.type)?.main &&
            this.pmoduleTaho.measurements.find(y => y.measurementId === x.id)
          );
        });

        const moduleId = this.pmoduleTaho?.id as number;
        const moduleGUID = this.pmoduleTaho?.guid as string;
        const moduleType = this.pmoduleTaho?.type as PModuleType;
        if (meanMeasurement && !this.comparedDiagrams.find(d => d.moduleGUID === moduleGUID))
          this.comparedDiagrams.push({
            id: uuidv4(),
            name: `${this.pmoduleTaho?.name}: ${meanMeasurement.shortName}`,
            moduleId: moduleId,
            moduleGUID: moduleGUID,
            moduleType: moduleType,
            measurement: meanMeasurement,
            visible: true,
          });

        // если ранее этот модуль был добавлен через синее меню, то удаляем его из списка отмеченных доступных модулей
        this.selectedPModulesGuids = this.selectedPModulesGuids.filter(
          (guid: string) => guid !== moduleGUID,
        );
      } else {
        this.pmoduleTaho = null;
      }
      // на главном графике оставляем только ПМ, отмеченные галкой через синее меню и ПМ, выбранный в настройках
      // и если основной сигнал - это сигналы трехосного dtcp-акселерометра, то все его оси
      this.comparedDiagrams = this.comparedDiagrams.filter(
        d =>
          this.selectedPModulesGuids.includes(d.moduleGUID) ||
          d.moduleGUID === this.selectedTahoGUID ||
          (d.moduleGUID === this.selectedAccelerometerGUID &&
            d.moduleType === PModuleType.DtcpAccelerometerModule),
      );
      // на открепленных графиков сигналов оставляем только ПМ, отмеченные галкой через синее меню
      this.detachedSignalDiagrams = this.detachedSignalDiagrams.filter(d =>
        this.selectedPModulesGuids.includes(d.moduleGUID),
      );

      this.resizedKey++;
    } catch {
      this.error = true;
    } finally {
      this.diagramLoading = false;
      this.vibrationDiagramLoading = false;
      this.angleDiagramLoading = false;
    }
  }

  //По идентификаторам датчиков возвращаем список объектов для графиков
  transformData(arrayIds: Array<DiagramSettings>) {
    const result: SignalDiagramData[] = [];
    arrayIds.forEach(x => {
      const pmodule = this.pmodules.filter(y => x.moduleGUID === y.guid)[0];

      const measurement = this.measurements.filter(y => x.measurementId === y.id)[0];

      if (pmodule && measurement) {
        const moduleId = pmodule?.id as number;
        const moduleType = pmodule?.type as PModuleType;

        result.push({
          id: uuidv4(),
          name: `${pmodule?.name}: ${measurement.shortName}`,
          moduleId: moduleId,
          moduleGUID: x.moduleGUID,
          moduleType: moduleType,
          measurement: measurement,
          color: x.color,
          isYLogAxis: x.isYLogAxis,
          visible: true,
        });
      }
    });
    return result;
  }

  //По идентификаторам датчиков возвращаем список объектов для графиков
  transformDataSpectrum(arrayIds: Array<SpectrumDiagramSettings>) {
    const result: {
      itemFreqbands: Freqband[];
      mainDiagram: SpectrumDiagramData;
      comparedDiagrams: SpectrumDiagramData[];
    }[] = [];
    arrayIds.forEach(async x => {
      const pmodule = this.pmodules.filter(y => x.moduleGUID === y.guid)[0];

      const measurement = this.measurements.filter(y => x.measurementId === y.id)[0];

      if (pmodule && measurement) {
        const moduleId = pmodule?.id as number;
        const moduleType = pmodule?.type as PModuleType;
        const spectrumYAxisType = spectrumYAxisTypes.filter(
          st => st.value === x.spectrumYAxisType,
        )[0];

        await this.loadFreqbands(pmodule);

        // TODO: добавляем настройки графиков
        result.push({
          itemFreqbands: this.freqbandsForPModule.get(moduleId) ?? [],
          mainDiagram: {
            id: this.getSpectrumId(
              x.moduleGUID,
              measurement?.id as number,
              spectrumYAxisType?.value,
            ),
            name: this.getSpectrumTitle(
              pmodule?.name,
              measurement.shortName,
              spectrumYAxisType?.name,
            ),
            moduleId: moduleId,
            moduleGUID: x.moduleGUID,
            moduleType: moduleType,
            measurement: measurement,
            spectrumYAxisType: x?.spectrumYAxisType,
            color: x.color,
            freqbandId: x.freqbandId,
            isYLogAxis: x.isYLogAxis,
            hideZeroFrequency: x.hideZeroFrequency,
          },
          comparedDiagrams: [],
        });
      }
    });
    return result;
  }

  private selectValue: DatesIntervals = 'today';
  startDate = dateTimeIntervalHandle(this.selectValue).startDateTime;
  endDate = dateTimeIntervalHandle(this.selectValue).endDateTime;

  async created() {
    this.loading = true;
    await this.loadPModules();
    await this.loadMeasurements();
    const {data: dtcpAccelerometerModules} = await httpClient.get(
      '/dtcp-accelerometer-modules/sensor-types/',
    );
    this.dtcpAccelerometerModules = dtcpAccelerometerModules;
    this.comparedDiagrams = [];
    this.detachedSignalDiagrams = [];
    this.spectrumDiagrams = [];

    if (this.$route.params.id) {
      this.collectionId = parseInt(this.$route.params.id);
      // TODO: получаем из БД
      const model = await vibrationDiagnosticStoreModule.edit(this.collectionId);
      if (model && model.data) {
        if (model.data.accelerometerId) this.selectedAccelerometerGUID = model.data.accelerometerId;
        if (model.data.tahoId) this.selectedTahoGUID = model.data.tahoId;
        if (model.data.currentDateTimeInterval)
          this.currentDateTimeInterval = model.data.currentDateTimeInterval;
        else {
          this.setDateTimeInterval({startDateTime: this.startDate, endDateTime: this.endDate});
        }
        this.collectionName = model.data.name;
        if (model.data.comparedDiagrams) {
          this.comparedDiagrams = this.transformData(model.data.comparedDiagrams);
        }
        if (model.data.detachedSignalDiagrams) {
          this.detachedSignalDiagrams = this.transformData(model.data.detachedSignalDiagrams);
        }
        if (model.data.spectrumDiagrams) {
          this.spectrumDiagrams = this.transformDataSpectrum(model.data.spectrumDiagrams);
        }
        if (model.data.showAngleDiagram != null)
          this.showAngleDiagram = model.data.showAngleDiagram;
        if (model.data.diagramsToCompare) {
          this.diagramsToCompare = model.data.diagramsToCompare;
        }
      }

      this.selectedPModulesGuids = [
        ...new Set(
          this.comparedDiagrams
            .map(x => x.moduleGUID)
            .concat(this.detachedSignalDiagrams.map(x => x.moduleGUID)),
        ),
      ];

      this.selectedSpectrumsIds = [
        ...this.spectrumDiagrams.map(d =>
          this.getSpectrumId(
            d.mainDiagram.moduleGUID,
            d.mainDiagram.measurement?.id as number,
            d.mainDiagram.spectrumYAxisType,
          ),
        ),
      ];
      const {data} = await dtcpAccelerometerStoreModule.getById(this.selectedAccelerometerId);
      this.span_nodes = (data as PModuleWithMeasurements).span_nodes?.filter(
        (n: any) => !n.is_deleted,
      );

      if (this.span_nodes) {
        if (!dtcpTahoModule.all.length) {
          await dtcpTahoModule.fetchAll();
        }
        this.span_nodes = this.span_nodes.map((n: any) => {
          if (n.is_deleted) return n;
          if (!n.taho_module_uuid) return n;
          const taho = dtcpTahoModule.all.find(m => m.guid == n.taho_module_uuid);
          const newval = {
            ...n,
            taho_module: taho,
          };
          return newval;
        });
      }
    }

    this.setSyncDetachedSignalDiagrams();

    this.setSyncSpectrumDiagrams();

    const settings = await waterfallDiagramStoreModule.getWaterfallSettings();
    const savedData = await waterfallDiagramStoreModule.getDataBeforeZoom();
    if (settings) {
      this.initDateTimeInterval = savedData
        ? {...savedData.dateTimeInterval}
        : {...settings.currentDateTimeInterval};
      this.currentDateTimeInterval = {...settings.currentDateTimeInterval};
      this.selectedAccelerometerGUID = settings.accelerometerModuleGuid;
      if (settings.tahoModuleGuid) this.selectedTahoGUID = settings.tahoModuleGuid;
      await this.loadChart(true);
    } else {
      this.paramsDialog = true;
    }

    if (this.$route.params.openDialog == 'false') {
      this.paramsDialog = false;
      await this.loadChart(true);
    }
    this.loading = false;
  }

  // Загрузка Freqbands для модуля
  async loadFreqbands(pmodule: PModule) {
    // TODO: Можно добавить проверку на тип. Freqband есть не у всех модулей(сейчас только у DtcpAccelerometerModule).
    // .. но это убирает универсальность и нужно поддердивать список типов, у которых есть freqbands.
    // Если Freqbands уже есть для данного модуля, ничего не нужно делать.
    // pmodule.type !== PModuleType.DtcpAccelerometerModule ||
    if (pmodule.id === undefined || this.freqbandsForPModule.has(pmodule.id)) {
      return;
    }
    // const spectrumApiStore = dtcpAccelerometerModule;
    const spectrumApiStore = (pmoduleStoresByTypeMap.get(
      (pmodule.type as any) as PModuleType,
    ) as any) as PModuleStoreModule;
    if (!spectrumApiStore) {
      // не реализован стор для соотв модуля
      return;
    }

    const {data} = await spectrumApiStore.getById(pmodule.id);
    if (data) {
      const itemFreqbands = [
        ...this.getEnvelopeThreeDoctaveItems(data as DtcpAccelerometerModule),
        ...this.getEnvelopeOneDoctaveItems(data as DtcpAccelerometerModule),
      ].map(item => {
        return {
          id: Math.random(),
          central_frequency: item.central,
          bandwidth: item.width,
          name: this.getNameFreqbandItem(item.central, item.width),
        };
      });

      this.freqbandsForPModule.set(pmodule.id, itemFreqbands);
    }
  }

  // Загрузка программных модулей с измерениями
  async loadPModules() {
    try {
      this.pmodulesLoading = true;
      this.pmodulesError = false;
      const pmodules = await getAllModules();
      this.pmodules = pmodules.filter(x => x.measurements);
    } catch (e) {
      console.log('error: ', e);
      this.pmodulesError = true;
    } finally {
      this.pmodulesLoading = false;
    }
  }

  async loadMeasurements() {
    await measurementsModule.fetchAll();
    this.measurements = [...measurementsModule.all];
  }

  async loadAccelerometer() {
    return await this.pmodules.filter(
      (pm: PModuleWithMeasurements) => pm.type === PModuleType.DtcpAccelerometerModule,
    );
  }

  async loadTaho() {
    return await this.pmodules.filter(
      (pm: PModuleWithMeasurements) =>
        pm.type === PModuleType.CrmModule || pm.type === PModuleType.DtcpTahoModule,
    );
  }

  //Сохраняем набор выбранных датчиков и их распределение на странице либо на главной диаграмме сигналов либо в отдельных диаграммах
  async onSaveCollection() {
    this.loading = true;
    this.formCollectionNameValid = await (this.$refs.formCollectionName as any).validate();

    if (!this.formCollectionNameValid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      this.textHint = 'Укажите название набора';
      this.saveHint = true;
      this.loading = false;
      return;
    }
    // Cохряняем выбраные настройки из local storage в БД внутри наборов диаграм
    const comparedDiagrams = await Promise.all(
      this.comparedDiagrams
        .filter(x => x.moduleGUID !== this.selectedTahoGUID)
        .map(async x => {
          const diagramSetting = await userSettingsStoreModule.getTempDiagramSettings({
            pModuleId: x.moduleId,
            measurementId: x.measurement.id,
            measurementType: x.measurement.type,
          });
          return {
            moduleGUID: x.moduleGUID as string,
            measurementId: x.measurement.id as number,
            isYLogAxis: diagramSetting?.isYLogAxis ?? x.isYLogAxis,
            color: diagramSetting?.color ?? x.color,
            hideZeroFrequency: diagramSetting?.hideZeroFrequency,
          };
        }),
    );

    const detachedSignalDiagrams = await Promise.all(
      this.detachedSignalDiagrams.map(async x => {
        const diagramSetting = await userSettingsStoreModule.getTempDiagramSettings({
          pModuleId: x.moduleId,
          measurementId: x.measurement.id,
          measurementType: x.measurement.type,
        });
        return {
          moduleGUID: x.moduleGUID as string,
          measurementId: x.measurement.id as number,
          isYLogAxis: diagramSetting?.isYLogAxis ?? x.isYLogAxis,
          color: diagramSetting?.color ?? x.color,
          hideZeroFrequency: diagramSetting?.hideZeroFrequency,
        };
      }),
    );

    const spectrumDiagrams = await Promise.all(
      this.spectrumDiagrams.map(async x => {
        const diagramSetting = await userSettingsStoreModule.getTempDiagramSettings({
          pModuleId: x.mainDiagram.moduleId,
          measurementId: x.mainDiagram.measurement.id,
          measurementType: x.mainDiagram.measurement.type,
        });
        return {
          moduleGUID: x.mainDiagram.moduleGUID as string,
          measurementId: x.mainDiagram.measurement.id as number,
          spectrumYAxisType: x.mainDiagram.spectrumYAxisType,
          hideZeroFrequency: diagramSetting?.hideZeroFrequency ?? x.mainDiagram.hideZeroFrequency,
          isYLogAxis: diagramSetting?.isYLogAxis ?? x.mainDiagram.isYLogAxis,
          color: diagramSetting?.color ?? x.mainDiagram.color,
          freqbandId: diagramSetting?.freqbandId ?? x.mainDiagram.freqbandId,
        };
      }),
    );

    try {
      // TODO: сохранение должно проходить в бд
      await vibrationDiagnosticStoreModule.save({
        id: this.collectionId,
        name: this.collectionName,
        accelerometerId: this.selectedAccelerometerGUID,
        tahoId: this.selectedTahoGUID,
        // startDateTime: this.currentDateTimeInterval.startDateTime,
        // endDateTime: this.currentDateTimeInterval.endDateTime,
        currentDateTimeInterval: this.currentDateTimeInterval,
        comparedDiagrams: comparedDiagrams,
        detachedSignalDiagrams: detachedSignalDiagrams,
        spectrumDiagrams: spectrumDiagrams,
        diagramsToCompare: this.diagramsToCompare,
        showAngleDiagram: this.showAngleDiagram,
      });
      this.textHint = 'Набор сохранен';
    } catch {
      this.error = true;
      this.textHint = 'Произошла ошибка';
    } finally {
      this.saveHint = true;
      this.loading = false;
    }
  }

  showLegendMenu = false;
  itemsLegendMenu = [
    {action: VibrationDiagnosticAction.Detach, title: 'Вынести в новый график'},
    {action: VibrationDiagnosticAction.ChangeVisibility, title: ''},
    {action: VibrationDiagnosticAction.Delete, title: 'Удалить'},
  ];

  showDiagramsToCompareLegendMenu = false;
  diagramsToCompareItemsLegendMenu = [
    {action: VibrationDiagnosticAction.ChangeVisibility, title: ''},
    {action: VibrationDiagnosticAction.Delete, title: 'Удалить'},
  ];

  //Координаты меню при клике на элемент легенды
  xLegendMenu = 0;
  yLegendMenu = 0;

  clickedDiagramVisibility = true;
  clickedDiagramToCompareVisibility = true;

  //идентификтор диаграммы для которой необходимо показать меню
  clickedDiagramId!: string;
  clickedDiagramIndex!: any;

  //Список графиков, которые должны быть показаны в отдельных диаграммах
  detachedSignalDiagrams: SignalDiagramData[] = [];

  //хак для корректного отображения меню
  keyMenu = 0;

  //клик по элементу легенды диаграммы
  onItemLegendClicked(data: {diagramId: string; x: number; y: number}) {
    this.showLegendMenu = false;
    const diagram = this.comparedDiagrams.filter(d => d.id === data.diagramId)[0];
    // Если в настройках у нас выбран тахометр, то мы его не можем удалить или открепить с помощью легенды, только через кнопку меню
    if (diagram.moduleGUID === this.pmoduleTaho?.guid) return;

    this.xLegendMenu = data.x;
    this.yLegendMenu = data.y;
    this.clickedDiagramId = data.diagramId;
    this.clickedDiagramVisibility = diagram.visible;
    this.$nextTick(() => {
      this.keyMenu++;
      this.showLegendMenu = true;
    });
  }

  onDiagramsToCompareItemLegendClicked(data: {id: string; index: any; x: number; y: number}) {
    this.showDiagramsToCompareLegendMenu = false;
    const diagrams = this.diagramsToCompare.find(x => x[0].id == data.id);
    const diagram = diagrams[data.index];

    this.xLegendMenu = data.x;
    this.yLegendMenu = data.y;
    this.clickedDiagramId = data.id;
    this.clickedDiagramIndex = data.index;
    this.clickedDiagramToCompareVisibility = diagram.visible;
    this.$nextTick(() => {
      this.keyMenu++;
      this.showDiagramsToCompareLegendMenu = true;
    });
  }

  //Установка выбранных модулей в соответствии со списком датчиков на главном графике и в отдельных диаграммах
  setSelectedPModulesGuids() {
    this.selectedPModulesGuids = this.selectedPModulesGuids.filter((guid: string) => {
      const pmodule = this.pmodules.filter(x => x.guid === guid)[0];

      const signalExists = pmodule.measurements.some(
        x =>
          this.comparedDiagrams.find(y => y.measurement.id === x.measurementId) ||
          this.detachedSignalDiagrams.find(y => y.measurement.id === x.measurementId),
      );

      //если для ранее выбранного модуля не осталось графиков сигнала ни в сравниваемых графиках, ни в открепленных, то удаляем спектры для данного модуля
      if (!signalExists) {
        this.spectrumDiagrams = this.spectrumDiagrams.filter(
          d => d.mainDiagram.moduleGUID !== guid,
        );

        this.setSyncSpectrumDiagrams();
      }

      return signalExists;
    });
  }

  //Удаление с главной диаграммы графика при выборе соотв. пункта меню
  removeFromComparedDiagrams() {
    this.comparedDiagrams = this.comparedDiagrams.filter(d => d.id !== this.clickedDiagramId);

    this.setSelectedPModulesGuids();
  }

  changeDiagramVisibility(visible: any) {
    this.comparedDiagrams = this.comparedDiagrams.map((d: any) => {
      if (d.id === this.clickedDiagramId) d.visible = visible;
      return d;
    });
  }

  onMenuItemClicked(item: any) {
    if (this.clickedDiagramId && item.action === VibrationDiagnosticAction.Delete) {
      this.removeFromComparedDiagrams();
    }
    if (this.clickedDiagramId && item.action === VibrationDiagnosticAction.Detach) {
      const diagram = this.comparedDiagrams.filter(d => d.id === this.clickedDiagramId)[0];
      this.detachedSignalDiagrams.push(diagram);
      this.removeFromComparedDiagrams();

      this.setSyncDetachedSignalDiagrams();
    }
    if (this.clickedDiagramId && item.action === VibrationDiagnosticAction.ChangeVisibility) {
      this.changeDiagramVisibility(!this.clickedDiagramVisibility);
    }
  }

  onDiagramToCompareMenuItemClicked(item: any) {
    if (this.clickedDiagramId && item.action === VibrationDiagnosticAction.Delete) {
      this.diagramToCompareSpectrumRemove();
    }
    if (this.clickedDiagramId && item.action === VibrationDiagnosticAction.ChangeVisibility) {
      this.changeDiagramToCompareVisibility(!this.clickedDiagramToCompareVisibility);
    }
  }

  diagramToCompareSpectrumRemove() {
    const index = this.diagramsToCompare.findIndex(x => x[0].id == this.clickedDiagramId);
    const diagram = this.diagramsToCompare[index][this.clickedDiagramIndex];
    this.diagramsToCompare[index] = this.diagramsToCompare[index].filter((x: any) => x != diagram);
    if (!this.diagramsToCompare[index].length)
      this.diagramsToCompare = this.diagramsToCompare.filter(
        x => this.diagramsToCompare.indexOf(x) != this.diagramsToCompare[index],
      );
    this.showDiagramsToCompareLegendMenu = false;
  }

  changeDiagramToCompareVisibility(visible: any) {
    const index = this.diagramsToCompare.findIndex(x => x[0].id == this.clickedDiagramId);
    this.diagramsToCompare[index][this.clickedDiagramIndex].visible = visible;
    this.showDiagramsToCompareLegendMenu = false;
    this.diagramsKey++;
  }

  // Действия при удалении карточки графика
  onRemoveSignalDiagram(diagram: any) {
    this.detachedSignalDiagrams = this.detachedSignalDiagrams.filter(d => d.id !== diagram.id);

    this.setSyncDetachedSignalDiagrams();

    this.setSelectedPModulesGuids();

    if (
      !this.detachedSignalDiagrams.length &&
      !this.spectrumDiagrams.length &&
      !this.diagramsToCompare.length
    )
      this.edit = false;
  }

  onRemoveDiagramToCompare(diagram: any) {
    this.diagramsToCompare = this.diagramsToCompare.filter(d => d[0].id != diagram[0].id);

    if (
      !this.detachedSignalDiagrams.length &&
      !this.spectrumDiagrams.length &&
      !this.diagramsToCompare.length
    )
      this.edit = false;
  }

  onRemoveSpectrumDiagram(diagram: any) {
    this.spectrumDiagrams = this.spectrumDiagrams.filter(d => d.mainDiagram.id !== diagram.id);

    this.setSyncSpectrumDiagrams();

    if (
      !this.detachedSignalDiagrams.length &&
      !this.spectrumDiagrams.length &&
      !this.diagramsToCompare.length
    )
      this.edit = false;
  }

  // Диалоговое окно для выбора спектров
  addSpectrumsDialog = false;

  // Список выбранных спектров
  selectedSpectrumsIds: string[] = [];

  // Сохраняем выбранные идентификаторы спектров при открытии диалога
  dialogSelectedSpectrumsIds: string[] = [];

  @Watch('addSpectrumsDialog')
  onSpectrumDialog(value: boolean) {
    if (value) this.dialogSelectedSpectrumsIds = [...this.selectedSpectrumsIds];
  }

  getSpectrumId(moduleGUID: string, measurementId: number, spectrumYAxisType?: SpectrumYAxisType) {
    return `${moduleGUID}-${measurementId}-${spectrumYAxisType}`;
  }

  getSpectrumTitle(moduleName: string, measurementName: string, spectrumYAxisName?: string) {
    const baseName = `${moduleName}: ${measurementName}`;
    return spectrumYAxisName ? `${baseName}, ${spectrumYAxisName}` : baseName;
  }

  getSpectrum(guids: any, getFreqbands: boolean) {
    const spectrums: Array<{
      id: string;
      name: string;
      moduleId: number;
      moduleGUID: string;
      moduleType: PModuleType;
      measurement: any;
      spectrumYAxisType?: SpectrumYAxisType;
      freqbands: Freqband[];
    }> = [];

    guids.forEach(async (guid: string) => {
      const pmodule = this.pmodules.find(x => x.guid === guid);

      if (!pmodule) return;

      if (getFreqbands) await this.loadFreqbands(pmodule);

      pmodule.measurements.forEach(x => {
        const measurement = this.measurements.find(y => y.id === x.measurementId);
        if (!measurement || measurement.type !== MeasurementType.Spectrum) return;

        const moduleId = pmodule?.id as number;
        const moduleGUID = pmodule?.guid as string;
        const moduleType = pmodule?.type as PModuleType;

        if (measurement.spectrumType === SpectrumEventType.Low) {
          spectrumYAxisTypes.forEach((item: {value: SpectrumYAxisType; name: string}) => {
            spectrums.push({
              id: this.getSpectrumId(moduleGUID, measurement?.id as number, item.value),
              name: this.getSpectrumTitle(pmodule?.name, measurement.shortName, item.name),
              moduleId: moduleId,
              moduleGUID: moduleGUID,
              moduleType: moduleType,
              measurement: measurement,
              freqbands: this.freqbandsForPModule.get(moduleId) ?? [],
              spectrumYAxisType: item.value,
            });
          });
        } else {
          spectrums.push({
            id: this.getSpectrumId(moduleGUID, measurement?.id as number),
            name: this.getSpectrumTitle(pmodule?.name, measurement.shortName),
            moduleId: moduleId,
            moduleGUID: moduleGUID,
            moduleType: moduleType,
            measurement: measurement,
            freqbands: this.freqbandsForPModule.get(moduleId) ?? [],
          });
        }
      });
    });
    return spectrums;
  }

  get allSpectrum() {
    const pmodules = this.pmodules.filter(
      (pm: PModuleWithMeasurements) => pm.type === PModuleType.DtcpAccelerometerModule,
    );
    const guids = Array.from(pmodules, x => x.guid);
    return this.getSpectrum(guids, false);
  }

  //Получаем список спектров модулей, для которых уже добавлены сигналы
  get spectrums() {
    const existingSignals: any[] = [];

    if (this.selectedAccelerometerGUID && !existingSignals.includes(this.selectedAccelerometerGUID))
      existingSignals.push(this.selectedAccelerometerGUID);
    if (this.selectedTahoGUID && !existingSignals.includes(this.selectedTahoGUID))
      existingSignals.push(this.selectedTahoGUID);
    return this.getSpectrum(existingSignals, true);
  }

  // Диаграммы спектров
  spectrumDiagrams: {
    itemFreqbands: Freqband[];
    mainDiagram: SpectrumDiagramData;
    comparedDiagrams: SpectrumDiagramData[];
  }[] = [];

  // Диаграммы спектров
  diagramsToCompare: any[] = [];

  //Действия при выборе спектров
  onSelectSpectrums() {
    this.selectedSpectrumsIds = [...this.dialogSelectedSpectrumsIds];
    this.addSpectrumsDialog = false;

    this.spectrumDiagrams = this.spectrumDiagrams.filter(d =>
      this.selectedSpectrumsIds.includes(
        this.getSpectrumId(
          d.mainDiagram.moduleGUID,
          d.mainDiagram.measurement?.id as number,
          d.mainDiagram.spectrumYAxisType,
        ),
      ),
    );

    this.selectedSpectrumsIds.forEach((id: string) => {
      const spectrum = this.spectrums.filter(s => s.id === id)[0];
      if (
        this.spectrumDiagrams.some(
          x =>
            x.mainDiagram.moduleGUID === spectrum.moduleGUID &&
            x.mainDiagram.measurement.id === spectrum.measurement.id &&
            x.mainDiagram.spectrumYAxisType === spectrum.spectrumYAxisType,
        )
      )
        return;

      this.spectrumDiagrams.push({
        mainDiagram: {
          id: uuidv4(),
          name: spectrum.name,
          moduleId: spectrum.moduleId,
          moduleGUID: spectrum.moduleGUID,
          moduleType: spectrum.moduleType,
          measurement: spectrum.measurement,
          spectrumYAxisType: spectrum.spectrumYAxisType,
        },
        comparedDiagrams: [],
        itemFreqbands: spectrum.freqbands ?? [],
      });
    });

    this.setSyncSpectrumDiagrams();
  }

  //для открепленных сигналов указываем что они синхронизируются
  setSyncDetachedSignalDiagrams() {
    diagramStoreModule.setCanSync({
      diagrams: [...this.detachedSignalDiagrams],
    });
  }

  //для спектров указываем что они синхронизируются
  setSyncSpectrumDiagrams() {
    spectrumDiagramStoreModule.setCanSync({
      diagrams: [...this.spectrumDiagrams.map(item => item.mainDiagram)],
    });
  }

  beforeDestroy() {
    userSettingsStoreModule.clearTempDiagramSettings();
    diagramStoreModule.clear();
    spectrumDiagramStoreModule.clear();
  }

  back() {
    router.push('/vibrationDiagnostic');
  }

  getEnvelopeDoctaveItems(
    name: 'envelope_3doctave' | 'envelope_1doctave',
    pmodule: DtcpAccelerometerModule,
  ): {central: number; width: number}[] {
    const base2 = pmodule[name].toString(2);
    const base2Length = base2.length - 1;
    let data: any[] = [];
    const module = this.dtcpAccelerometerModules.find(
      (item: any) => item.id === pmodule.sensor_type,
    );
    if (module) {
      data = module[name];
    }

    data = data
      .map(item => {
        return {
          ...item,
          isActive: base2[base2Length - item.bit] === '1',
          width: item.max - item.min,
        };
      })
      .filter(item => item.isActive);

    return data;
  }

  getEnvelopeThreeDoctaveItems(pmodule: DtcpAccelerometerModule) {
    return this.getEnvelopeDoctaveItems('envelope_3doctave', pmodule);
  }

  getEnvelopeOneDoctaveItems(pmodule: DtcpAccelerometerModule) {
    return this.getEnvelopeDoctaveItems('envelope_1doctave', pmodule);
  }
}
